<template>
  <div class="create-com-size">
    <div class="breadcrumb" style="background: #fff">查看尺寸组</div>
    <div class="order-detail-basic">
      <el-form :model="sizeGroupMsg" label-width="120px">
        <el-form-item label="尺寸组名称:">
          <span>{{ sizeGroupMsg.groupName }}</span>
        </el-form-item>
        <el-form-item label="尺寸组类:">
          <span>{{ sizeGroupMsg.composeSizeGroupCategory.categoryName }}</span>
        </el-form-item>
        <el-form-item label="页面名称:">
          <!-- <span>{{ sizeGroupMsg.pageName.slice(0, -1) }}</span> -->
          <span>{{ sizeGroupMsg.sizeList[0].pageName }}</span>
        </el-form-item>
        <el-form-item :label="$store.state.pms.pageType[item.pageTypeCode] + '尺寸:'" v-for="item in sizeGroupMsg.sizeList" :key="item.id">
          <el-table :data="[item]" style="width: 100%" border>
            <el-table-column prop="sizeName" label="尺寸名称"></el-table-column>
            <el-table-column label="页面类型">
              <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
            </el-table-column>
            <el-table-column prop="address" label="宽高">
              <template slot-scope="scope"> 宽:{{ scope.row.sizeWidth }}mm<br> 高:{{ scope.row.sizeHeight }}mm </template>
            </el-table-column>
            <el-table-column prop="bleed.bleedName" label="出血类型"></el-table-column>
            <el-table-column prop="address" label="出血" min-width="110px">
              <template slot-scope="scope"> 上方:{{ scope.row.bleed.bleedTop }}mm 下方:{{ scope.row.bleed.bleedBottom }}mm <br> 左侧:{{ scope.row.bleed.bleedLeft }}mm 右侧:{{ scope.row.bleed.bleedRight }}mm
                <br> 内侧:{{ scope.row.bleed.bleedIn }}mm </template>
            </el-table-column>
            <el-table-column prop="address" label="折线">
              <template slot-scope="scope">
                <p v-for="(val, key) in scope.row.brokenLine" :key="key + val">{{ key === 'HORIZONTAL' ? '水平折线' : key === 'VERTICAL' ? '垂直折线' : '未定义字段' }}:<span v-for="item in val" :key="item">{{ item
                    }}mm</span></p>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="码名称">
              <template slot-scope="scope">
                <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- <el-form-item label="关联SKU数量:">
          <span>{{sizeGroupMsg.pageName.slice(0,-1)}}</span>
        </el-form-item> -->
        <el-form-item label="显示尺寸:">
          <el-select v-model="sizeGroupMsg.composeSizeId" placeholder="请选择" @change="$forceUpdate()">
            <el-option v-for="item in associateLists" :key="item.id" :label="item.sizeName" :value="item.id"></el-option>
          </el-select>
          <el-button round type="primary" @click="dialogVisible = true" style="margin-left:15px">新建显示尺寸</el-button>
        </el-form-item>
        <el-form-item label="查看关联模板组:">
          <span class="color-blue" @click="checkTemplate()">{{ sizeGroupMsg.templateGroupNum }}</span>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round @click="checkSubmit" type="primary">确定</el-button>
    </div>
    <el-dialog :close-on-click-modal="false" width="75%" title="模板组" :visible.sync="templateDialog">
      <el-form :inline="true" :model="searchGroupVo" class="demo-form-inline">
        <el-form-item label="模板组名称:">
          <el-input v-model="searchGroupVo.groupName" placeholder="请输入模板组名称"></el-input>
        </el-form-item>
        <el-form-item label="模板组主题:">
          <el-select v-model="searchGroupVo.templateThemeId" clearable placeholder="请选择">
            <el-option v-for="item in sampleList" :key="item.id" :label="item.themeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板性质:">
          <el-select v-model="searchGroupVo.propertyId" clearable placeholder="请选择">
            <el-option v-for="item in propertyList" :key="item.id" :label="item.propertyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期:">
          <el-date-picker v-model="value" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item style="float:right;margin-right:20px">
          <el-button round @click="tempQueryInfo.pageNum = 1, getTemplateThemeList()">查询</el-button>
          <!-- <el-button round v-show="addCorrelation" @click="Correlation()" type="primary">关联</el-button>
          <el-button round v-show="!addCorrelation" @click="cancelCorrelation()" type="primary">取消关联</el-button>
          <el-button round v-show="!addCorrelation"
            @click="searchGroupVo.propertyId = propertyList[0].id,sizeGroupQueryInfo.pageNum=1,searchGroupVo.skuId='',addCorrelation=true,getTemplateThemeList()"
            type="primary">添加关联</el-button> -->
        </el-form-item>
      </el-form>
      <el-table :data="templateGroupList" border style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column prop="groupName" label="模板组名称"></el-table-column>
        <el-table-column prop="propertyName" label="模板性质"></el-table-column>
        <el-table-column prop="payDate" label="模板数量">
          <template slot-scope="scope">
            <p v-for="item in scope.row.templateList" :key="scope.row.id + item.typeName">
              <span @click="getTemplateGroupMsg(scope.row.id), checkTemplateDialog = true" class="color-blue">{{ item.typeName + '模板：' + item.templateNum }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="themeName" label="主题"></el-table-column>
        <el-table-column prop="createdTime" label="创建日期"></el-table-column>
        <el-table-column prop="createdTime" label="是否默认加载">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.sizeDefaultDownload" :inactive-value="0" :active-value='1' @change="sizeGroupSetDownloadTemplateGroup(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="是否默认使用">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.defaultUse" @change="sizeGroupSetDefaultTemplateGroup(scope.row)"></el-switch>
          </template>
        </el-table-column>
      </el-table>
      <v-pagination class="v-pagination" :queryInfo="tempQueryInfo" @changePage="changePage"></v-pagination>
      <el-dialog :close-on-click-modal="false" width="50%" title="查看模板" :visible.sync="checkTemplateDialog" append-to-body>
        <img style="width:150px;margin:0 5px 5px 0;border:2px solid #000" v-for="item in templateList" :key="item.id + item.sorting" :src="item.templateThumbnail" alt="">
      </el-dialog>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="新建显示尺寸" @closed='dialogVisible = false' :visible.sync="dialogVisible" width="700px">
      <el-form hide-required-asterisk :model="createComSize" ref="createForm" label-width="130px">
        <el-form-item label="显示尺寸名称:" prop="sizeName">
          <el-input v-model="createComSize.sizeName" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="宽高:">
          <el-form-item label="" style="margin:0;float:left" label-width="0" prop="sizeWidth">
            <el-input placeholder="" v-model="createComSize.sizeWidth" style="width:210px">
              <template slot="prepend">宽</template>
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" style="margin:0;float:left" label-width="0" prop="sizeHeight">
            <el-input placeholder="" v-model="createComSize.sizeHeight" style="width:210px">
              <template slot="prepend">高</template>
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label="位置:">
          <el-form-item label="" style="margin:0;float:left" label-width="0" prop="topParam">
            <el-input placeholder="" v-model="createComSize.topParam" style="width:210px">
              <template slot="prepend">距上</template>
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" style="margin:0;float:left" label-width="0" prop="leftParam">
            <el-input placeholder="" v-model="createComSize.leftParam" style="width:210px">
              <template slot="prepend">距左</template>
              <template slot="append">mm</template>
            </el-input>
          </el-form-item>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitSize(sizeId)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { associateAdd, composeGroupDetail, propertyGetPropertyList, sampleListNoPaging, getGroupListByComposeSizeGroupId, sizeGroupSetDefaultTemplateGroup, sizeGroupSetDownloadTemplateGroup, associateList, relevanceAssociate } from '@/api/pms'
export default {
  components: {
    VPagination
  },
  data () {
    return {
      associateLists: [],
      dialogVisible: false,
      salemanList: [],
      templateList: [],
      checkTemplateDialog: false,
      templateGroupList: [],
      value: '',
      sampleList: [],
      propertyList: [],
      templateDialog: false,
      searchGroupVo: {
        auditStatus: '',
        composeSizeGroupId: +this.$route.query.id,
        createTimeBegin: '',
        createTimeEnd: '',
        groupBelong: '',
        groupName: '',
        isAssociatedeSizeGroup: '',
        page: 1,
        propertyId: '',
        skuId: '',
        templateThemeId: ''
      },
      tableData: [{}],
      createComSize: {
        sizeHeight: '',
        sizeName: '',
        sizeWidth: '',
        leftParam: '',
        topParam: ''
      },
      sizeType: [],
      sizeGroupMsg: {
        composeSizeGroupCategory: {},
        pageName: '',
        composeSizeId: ''
      },
      sizePageTypeList: [],
      tempQueryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  watch: {
    value (val) {
      if (val) {
        this.searchGroupVo.createTimeBegin = val[0]
        this.searchGroupVo.createTimeEnd = val[1]
      } else {
        this.searchGroupVo.createTimeBegin = ''
        this.searchGroupVo.createTimeEnd = ''
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  async created () {
    await this.getAssociateList()
    this.getSizeGroupDetail()
  },
  methods: {
    async getAssociateList (sizeName = '') {
      let res = await associateList({ sizeName })
      if (res.data.success) {
        this.associateLists = res.data.data
      }
    },
    async submitSize () {
      let { leftParam, sizeHeight, sizeName, sizeWidth, topParam } = this.createComSize
      let displaySizeVO = {
        leftParam,
        sizeHeight,
        sizeName,
        sizeWidth,
        topParam
      }
      let res = await associateAdd(displaySizeVO)
      if (res.data.success) {
        this.$message.success('添加成功')
        this.dialogVisible = false
        this.getAssociateList()
      }
    },
    async checkSubmit () {
      if (this.sizeGroupMsg.composeSizeId) {
        let res = await relevanceAssociate({
          groupId: this.$route.query.id,
          composeSizeIdSet: [this.sizeGroupMsg.composeSizeId]
        })
        if (res.data.success) {
          this.$router.push('/compound')
        }
      } else {
        this.$router.push('/compound')
      }
    },
    checkTemplate () {
      this.getFormatList()
      this.SampleList()
      this.getTemplateThemeList()
      this.templateDialog = true
    },
    sizeGroupSetDownloadTemplateGroup (val) {
      let data = {
        // isDownload: !val.skuDefaultDownload ? 0 : 1,
        isDownload: !val.sizeDefaultDownload ? 0 : 1,
        id: +this.$route.query.id,
        templateGroupId: val.id
      }
      sizeGroupSetDownloadTemplateGroup(data)
        .then(res => {
          if (res.data.success) {
            this.$message.success('设置完成')
            this.getTemplateThemeList()
          }
        })
    },
    sizeGroupSetDefaultTemplateGroup (val) {
      let data = {
        act: val.defaultTemplateGroupId === val.id ? 0 : 1,
        id: +this.$route.query.id,
        defaultTemplateGroupId: val.id
      }
      sizeGroupSetDefaultTemplateGroup(data)
        .then(res => {
          if (res.data.success) {
            this.$message.success('设置完成')
            this.getTemplateThemeList()
          }
        })
    },
    getTemplateThemeList () {
      getGroupListByComposeSizeGroupId({ pageSize: this.tempQueryInfo.pageSize, pageNum: this.tempQueryInfo.pageNum, data: this.searchGroupVo })
        .then(res => {
          if (res.data.success) {
            let list = res.data.data.records
            list.forEach(item => {
              console.log(item.defaultTemplateGroupId === item.id)
              item.defaultUse = item.defaultTemplateGroupId === item.id
            })
            this.templateGroupList = list
            this.tempQueryInfo.total = res.data.data.total
          }
        })
    },
    // 获取模板性质列表
    getFormatList () {
      propertyGetPropertyList().then(res => {
        if (res.data.success) {
          let list = []
          this.sizeGroupMsg.sizeList.forEach(item => {
            list.push(item.spuPageName.templateProperty)
          })
          list = list.join('1')
          this.propertyList = res.data.data.filter(item => {
            return list.indexOf(item.propertyName) !== -1
          })
        }
      })
    },
    SampleList () {
      sampleListNoPaging().then(res => {
        if (res.data.success) {
          this.sampleList = res.data.data
        }
      })
    },
    changePage (val) {
      this.tempQueryInfo = val
      this.getTemplateThemeList()
    },
    // 查询尺寸组详情
    getSizeGroupDetail () {
      composeGroupDetail(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.sizeGroupMsg = res.data.data
          this.sizeGroupMsg.composeSizeId = res.data.data.displaySizeList.length > 0 ? res.data.data.displaySizeList[0].id : ''
          this.sizeGroupMsg.sizeList.forEach(item => {
            item.brokenLine = {}
            item.composeSizeBrokenLineXrefList.forEach(val => {
              if (!item.brokenLine[val.brokenLineDirection]) {
                item.brokenLine[val.brokenLineDirection] = []
              }
              item.brokenLine[val.brokenLineDirection].push(val.brokenLineValue)
            })
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.create-com-size {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: auto;

      @{deep} .el-input__inner {
        width: 65px;
      }
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }
}
</style>
